var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInficon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.572266,
    y: 0.927734,
    width: 17.8172,
    height: 18,
    rx: 8.9086,
    fill: "#FB2E5F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1328 7.43555V14.9277H8.99805V7.43555H10.1328ZM9.5791 4.63281C9.76595 4.63281 9.92546 4.69434 10.0576 4.81738C10.1943 4.93587 10.2627 5.12272 10.2627 5.37793C10.2627 5.62858 10.1943 5.81543 10.0576 5.93848C9.92546 6.06152 9.76595 6.12305 9.5791 6.12305C9.38314 6.12305 9.21908 6.06152 9.08691 5.93848C8.95931 5.81543 8.89551 5.62858 8.89551 5.37793C8.89551 5.12272 8.95931 4.93587 9.08691 4.81738C9.21908 4.69434 9.38314 4.63281 9.5791 4.63281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInficon);
export default __webpack_public_path__ + "static/media/inficon.2dca5dfb00714c81896e9f0ab3b3479a.svg";
export { ForwardRef as ReactComponent };